module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Complete registration"},"login":"Login","title":"Complete registration","resend":"Resend verification email.","back":"Go to homepage","sent":"New verification email sent!","success":"You have successfully signed up!","loginNow":"You can now login.","checkEmail":"Please check your inbox to verify your email address."}}')
  delete Component.options._Ctor
}
